import React, { useEffect } from 'react'
import { Skeleton, Box } from '@mui/material'
import { IconSeeker } from '@ui-seeker/core'
import { AppTableSeeker } from "@components"

import { useToast } from '@hooks'
import { isLoadingCommonFilters } from '@signals'
import { WEBBACK_V2_API } from '@constants'
import { embargoDateColumn, embargoStatusColumn, retailerColumn, productNameColumn, firstSeenColumn, lastSeenColumn, numDaysAvailableColumn } from './columns'
import {useCustomDashboardFilters} from "../@hooks";
import CreateReportButton from "./actions/CreateReportButton";


export default function EmbargoDateTable() {

	const { data } = useCustomDashboardFilters()
	const { showToast } = useToast()

	useEffect(() => {
		return () => {
			isLoadingCommonFilters.value = false
		}
	}, [])

	const columns = [
		...retailerColumn(),
		...productNameColumn(),
		embargoDateColumn(),
		firstSeenColumn(),
		lastSeenColumn(),
		numDaysAvailableColumn(),
		...embargoStatusColumn()
	]

	if(isLoadingCommonFilters.value) {
		return <Skeleton variant='rectangular' height={500} />
	}else if(!data.length) {
		return null
	}
	return <AppTableSeeker
		data={data}
		title={<Box sx={{ display: 'flex', alignItems:'center', justifyContent:'start', gap: 1 }} ><IconSeeker icon="clock" iconWeight='thin' />Embargo Date</Box>}
		columns={columns}
		options={{
			tableBodyHeight: '700',
			onDownload: () => showToast.promiseExcel(`${WEBBACK_V2_API}/custom-dash/embargo/excel`),
			viewColumns: false,
			customToolbar: () => <CreateReportButton />
		}}
	/>
}